import classNames from 'classnames';
import {TBaseGridProps, TColumnCount} from 'components/Grid/types';
import React, {memo, ReactNode, useMemo} from 'react';
import boxStyle from 'styles/box.module.scss';

const DEFAULT_AS: TBaseGridProps['as'] = 'div';

export const Box = React.memo(
    React.forwardRef<any, TBaseGridProps>(function Box(
        {children, className, as = DEFAULT_AS, commonPaddingOnMobileTablet = false, ...rest},
        ref,
    ) {
        const Component = as;
        return (
            <Component
                ref={ref}
                className={classNames(
                    boxStyle.box,
                    'grid-box',
                    className,
                    commonPaddingOnMobileTablet ? boxStyle.commonPaddingOnMobileTablet : '',
                )}
                {...rest}
            >
                {children}
            </Component>
        );
    }),
);

interface IRowProps {
    isNoOffset?: boolean;
}
export const Row = memo<TBaseGridProps & IRowProps>(function Row({
    children,
    isNoOffset,
    as = DEFAULT_AS,
    className,
    ...restProps
}) {
    const Component = as;

    return (
        <Component className={classNames(boxStyle.row, {[boxStyle.noOffsetRow]: isNoOffset}, className)} {...restProps}>
            {children}
        </Component>
    );
});

export interface IColProps {
    sm?: TColumnCount;
    md?: TColumnCount;
    lg?: TColumnCount;
    xl?: TColumnCount;
    isNoOffset?: boolean;
}

export const Col = memo<TBaseGridProps & IColProps>(function Col({
    children,
    sm,
    md,
    lg,
    xl,
    isNoOffset,
    as = DEFAULT_AS,
    className,
}) {
    const Component = as;

    const colClassName = useMemo(() => {
        return classNames(
            boxStyle.col,
            {
                [boxStyle[`colSm${sm}`]]: Boolean(sm),
                [boxStyle[`colMd${md}`]]: Boolean(md),
                [boxStyle[`colLg${lg}`]]: Boolean(lg),
                [boxStyle[`colXl${xl}`]]: Boolean(xl),
                [boxStyle.noOffsetCol]: isNoOffset,
            },
            className,
        );
    }, [className, isNoOffset, lg, md, sm, xl]);
    return <Component className={colClassName}>{children}</Component>;
});

export const wrapToBoxRowCol = (children: ReactNode) => (
    <Box>
        <Row>
            <Col>{children}</Col>
        </Row>
    </Box>
);
